import React from 'react';
import { DomainIcon } from '@billda/design-system';
import { MetricDisplay } from '../atoms/MetricDisplay';
import { formatCurrencyWhole } from '../../../../../shared/utils/currency';

interface SiteMetricsDisplayProps {
  totalLabourPrice: number;
  plotCount: number;
}

export const SiteMetricsDisplay: React.FC<SiteMetricsDisplayProps> = ({
  totalLabourPrice,
  plotCount,
}) => {
  return (
    <div className="flex gap-4">
      <div className="flex-1">
        <MetricDisplay
          label="Total Value"
          value={formatCurrencyWhole(totalLabourPrice)}
          color="text-content-accent"
        />
      </div>
      <div className="flex-1">
        <MetricDisplay
          label="Plots"
          value={plotCount}
          icon={
            <DomainIcon
              className="size-3.5 text-content-secondary"
              aria-hidden="true"
            />
          }
        />
      </div>
    </div>
  );
};
